  // setTimeout(function(){
//   fetch('https://new-era.io/api/v2/average/stats/today?number=7')
//   .then(res => res.json())
//   .then(data => {
//     const zittauSum = data.data.zittau.reduce((a,b) => a + b.average, 0);
//     const halleSum = data.data.halle.reduce((a,b) => a + b.average, 0);
//     const sevenDaysAvg = Math.floor(((zittauSum / 7) + (halleSum / 7))/2);
//   	if(sevenDaysAvg > 23){
//             document.getElementById("arrival-days").innerHTML = '• Versandzeit ca. 2-4 Wochen';
//         }else if (sevenDaysAvg > 14 && sevenDaysAvg < 24){
//             document.getElementById('arrival-days').innerHTML = '• Versandzeit ca. 2-3 Wochen';
//         }else if (sevenDaysAvg > 9 && sevenDaysAvg < 15){
//             document.getElementById('arrival-days').innerHTML = '• Versandzeit ca. 1-2 Wochen';
//         }else if (sevenDaysAvg > 5 && sevenDaysAvg < 10){
//             document.getElementById('arrival-days').innerHTML = '• Versandzeit ca. 3-5 Tage';
//         }else if (sevenDaysAvg > 0 && sevenDaysAvg < 6){
//             document.getElementById('arrival-days').innerHTML = '• Versandzeit ca. 1-3 Tage';
//         }
//   })
//   .catch(e => console.error(e));

// }, 200);
console.log("test")

const germanDates_ = {
    monday: 'Montag',
    tuesday: 'Dienstag',
    wednesday: 'Mittwoch',
    thursday: 'Donnerstag',
    friday: 'Freitag',
    saturday: 'Samstag',
    sunday: 'Sonntag'
}

const germanMonths = {
    january: 'Januar',
    february: 'Februar',
    march: 'März',
    april: 'April',
    may: 'Mai',
    june: 'Juni',
    july: 'Juli',
    august: 'August',
    september: 'September',
    october: 'Oktober',
    november: 'November',
    december: 'Dezember'
}

function getGermanDate(date) {
    if (date == 'Mon') {
        date = germanDates_.monday
    }
    else if (date == 'Tue') {
        date = germanDates_.tuesday
    }
    else if (date == 'Wed') {
        date = germanDates_.wednesday
    }
    else if (date == 'Thu') {
        date = germanDates_.thursday
    }
    else if (date == 'Fri') {
        date = germanDates_.friday
    }
    else if (date == 'Sat') {
        date = germanDates_.saturday
    }
    else if (date == 'Sun') {
        date = germanDates_.sunday
    }
    return date
}

function getGermanMonth(date) {
    if (date == 'Jan') {
        date = germanMonths.january
    }
    else if (date == 'Feb') {
        date = germanMonths.february
    }
    else if (date == 'Mar') {
        date = germanMonths.march
    }
    else if (date == 'Apr') {
        date = germanMonths.april
    }
    else if (date == 'May') {
        date = germanMonths.may
    }
    else if (date == 'Jun') {
        date = germanMonths.june
    }
    else if (date == 'Jul') {
        date = germanMonths.july
    }
    else if (date == 'Aug') {
        date = germanMonths.august
    }
    else if (date == 'Sep') {
        date = germanMonths.september
    }
    else if (date == 'Oct') {
        date = germanMonths.october
    }
    else if (date == 'Nov') {
        date = germanMonths.november
    }
    else if (date == 'Dec') {
        date = germanMonths.december
    }
    return date
}

const currentDate = new Date();
currentDate.setDate(currentDate.getDate() + 30)
const currentDateArr = currentDate.toUTCString().split(" ").slice(0, 3);

setTimeout(function () {
  console.log("test2")
    function getDateFromHours(time) {
        time = time.split(':');
        let now = new Date();
        return new Date(now.getFullYear(), now.getMonth(), now.getDate(), ...time);
    }

    const currentTime = new Date().toTimeString().split(" ")[0]
    const referentTime = '13:00:00';
    const hours = getDateFromHours(referentTime).getHours();
    if ((getDateFromHours(referentTime) - getDateFromHours(currentTime)) > 0) {
      document.getElementById("return-policy").innerHTML = `Rücksendung bis ${getGermanDate(currentDateArr[0].replace(',', ''))}, ${currentDateArr[1]} ${getGermanMonth(currentDateArr[2])} möglich`; //aaaaaaaa
      console.log(`Rücksendung bis ${getGermanDate(currentDateArr[0].replace(',', ''))}, ${currentDateArr[1]} ${getGermanMonth(currentDateArr[2])} möglich`); //aaaaaaaa
        const timeLeft = getDateFromHours(referentTime) - getDateFromHours(currentTime);
        const date = new Date(timeLeft);
        const h = (date.getHours() + 24).toString();
        let timeLeftMinutes = (timeLeft / 1000) / 60;
        let minuteGerman = (timeLeftMinutes == 1) ? 'Minute' : 'Minuten';
        if (timeLeftMinutes > 60) {
            const timeLeftHours = Math.floor(timeLeftMinutes / 60);
            timeLeftMinutes = Math.floor(((timeLeftMinutes / 60) - timeLeftHours) * 60);
            let hourGerman = timeLeftHours == 1 ? 'Stunde' : 'Stunden';
            minuteGerman = timeLeftMinutes == 1 ? 'Minute' : 'Minuten';
//             document.getElementById("arrival-days-date").innerHTML = `${getGermanDate(getDateFromHours(h).toUTCString().split(" ").slice(0, 3).join(' ').split(" ")[0].split(',')[0])}, ${getDateFromHours(h).toUTCString().split(" ").slice(0, 3).join(' ').split(" ")[1]} ${getGermanMonth(getDateFromHours(h).toUTCString().split(" ").slice(0, 3).join(' ').split(" ")[2])}`;
//             document.getElementById("arrival-days-time").innerHTML = `${timeLeftHours} ${hourGerman} und ${timeLeftMinutes} ${minuteGerman}.`
        }
        else {
//             document.getElementById("arrival-days-date").innerHTML = `${getGermanDate(getDateFromHours(h).toUTCString().split(" ").slice(0, 3).join(' ').split(" ")[0].split(',')[0])}, ${getDateFromHours(h).toUTCString().split(" ").slice(0, 3).join(' ').split(" ")[1]} ${getGermanMonth(getDateFromHours(h).toUTCString().split(" ").slice(0, 3).join(' ').split(" ")[2])}`;
//             document.getElementById("arrival-days-time").innerHTML = `${Math.floor(timeLeftMinutes)} ${minuteGerman}.`
        }
    }
    else {
       if(document.querySelector("#return-policy")){
        
	document.getElementById("return-policy").innerHTML = `Rücksendung bis ${getGermanDate(currentDateArr[0].replace(',', ''))}, ${currentDateArr[1]} ${getGermanMonth(currentDateArr[2])} möglich`; //aaaaaaaa
        const endOfDay = new Date().setHours(24, 0);
        const timeLeft = endOfDay - getDateFromHours(currentTime)
        const date = new Date(timeLeft);
        const h = (date.getHours() + 48).toString();
        let timeLeftMinutes = ((timeLeft / 1000) / 60);
        let minuteGerman = timeLeftMinutes == 1 ? 'Minute' : 'Minuten';
        if (timeLeftMinutes > 60) {
            const timeLeftHours = Math.floor(timeLeftMinutes / 60);
            timeLeftMinutes = Math.floor(((timeLeftMinutes / 60) - timeLeftHours) * 60);
            let hourGerman = timeLeftHours == 1 ? 'Stunde' : 'Stunden';
            minuteGerman = timeLeftMinutes == 1 ? 'Minute' : 'Minuten';
//             document.getElementById("arrival-days-date").innerHTML = `${getGermanDate(getDateFromHours(h).toUTCString().split(" ").slice(0, 3).join(' ').split(" ")[0].split(',')[0])}, ${getDateFromHours(h).toUTCString().split(" ").slice(0, 3).join(' ').split(" ")[1]} ${getGermanMonth(getDateFromHours(h).toUTCString().split(" ").slice(0, 3).join(' ').split(" ")[2])}`;
//             document.getElementById("arrival-days-time").innerHTML = `${timeLeftHours + hours} ${hourGerman} und ${timeLeftMinutes} ${minuteGerman}.`
        }
        else {
//             document.getElementById("arrival-days-date").innerHTML = `${getGermanDate(getDateFromHours(h).toUTCString().split(" ").slice(0, 3).join(' ').split(" ")[0].split(',')[0])}, ${getDateFromHours(h).toUTCString().split(" ").slice(0, 3).join(' ').split(" ")[1]} ${getGermanMonth(getDateFromHours(h).toUTCString().split(" ").slice(0, 3).join(' ').split(" ")[2])}`;
//             document.getElementById("arrival-days-time").innerHTML = `${Math.floor(timeLeftMinutes)} ${minuteGerman}.`
        }
      }
     }
}, 1000);